/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import { NgClass } from "./ng_class";
import { NgComponentOutlet } from "./ng_component_outlet";
import { NgForOf, NgForOfContext } from "./ng_for_of";
import { NgIf, NgIfContext } from "./ng_if";
import { NgPlural, NgPluralCase } from "./ng_plural";
import { NgStyle } from "./ng_style";
import { NgSwitch, NgSwitchCase, NgSwitchDefault } from "./ng_switch";
import { NgTemplateOutlet } from "./ng_template_outlet";
export { NgClass, NgComponentOutlet, NgForOf, NgForOfContext, NgIf, NgIfContext, NgPlural, NgPluralCase, NgStyle, NgSwitch, NgSwitchCase, NgSwitchDefault, NgTemplateOutlet };
/**
 * A collection of Angular directives that are likely to be used in each and every Angular
 * application.
 */
export var /** @type {?} */ COMMON_DIRECTIVES = [
    NgClass,
    NgComponentOutlet,
    NgForOf,
    NgIf,
    NgTemplateOutlet,
    NgStyle,
    NgSwitch,
    NgSwitchCase,
    NgSwitchDefault,
    NgPlural,
    NgPluralCase,
];
//# sourceMappingURL=index.js.map